import { Box, Paper, Typography } from "@mui/material";
import type { TankData } from "../../models/WeeklyIncentiveData";
import { IncentiveTank } from "../../shared/components/IncentiveTank";
import type { SixZoneThresholds } from "../../constants/colors";

type Props = {
	tanks: TankData[];
	thresholds?: SixZoneThresholds;
};

export const IncentiveTanksPanel = ({ tanks, thresholds }: Props) => {
	return (
		<Paper
			elevation={2}
			sx={{
				display: "flex",
				flexDirection: "column",
				flex: 1,
				minHeight: 0,
			}}
		>
			<Box
				sx={{
					px: 2,
					py: 1,
					borderBottom: "1px solid",
					borderColor: "divider",
				}}
			>
				<Typography sx={{ fontSize: "1rem", fontWeight: 500 }}>
					Totals at a Glance
				</Typography>
			</Box>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					gap: 1,
					px: 1.5,
					pt: 1,
					pb: 0.75,
					flex: 1,
					minHeight: 0,
					alignItems: "stretch",
				}}
			>
				{tanks.map((tank) => (
					<IncentiveTank key={tank.tankKey} {...tank} thresholds={thresholds} />
				))}
			</Box>
		</Paper>
	);
};
